import { mapState } from 'vuex';
import moment from 'moment';

export default {
    data() {
        return {
            user,
        };
    },

    computed: {
        ...mapState([
            'translations',
            // 'user',
            'settings',
            'plugins',
        ]),
    },

    methods: {
        //from: https://gist.github.com/jed/982883
        generateUUID(a) {
            return a
                ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16)
                : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
                      /[018]/g,
                      this.generateUUID
                  );
        },

        resetComponent() {
            Object.assign(this.$data, this.$options.data.apply(this));

            if (typeof this.onCreated === 'function') {
                this.onCreated();
            }

            if (typeof this.onMounted === 'function') {
                this.onMounted();
            }
        },

        timeDifference(since) {
            var msPerMinute = 60 * 1000;
            var msPerHour = msPerMinute * 60;
            var msPerDay = msPerHour * 24;
            var msPerMonth = msPerDay * 30;
            var msPerYear = msPerDay * 365;

            var elapsed = new Date() - new Date(since);

            if (elapsed < msPerMinute) {
                return (
                    Math.round(elapsed / 1000) +
                    ' ' +
                    this.translations['general.seconds_ago']
                );
            } else if (elapsed < msPerHour) {
                return (
                    Math.round(elapsed / msPerMinute) +
                    ' ' +
                    this.translations['general.minutes_ago']
                );
            } else if (elapsed < msPerDay) {
                return (
                    Math.round(elapsed / msPerHour) +
                    ' ' +
                    this.translations['general.hours_ago']
                );
            } else if (elapsed < msPerMonth) {
                return (
                    Math.round(elapsed / msPerDay) +
                    ' ' +
                    this.translations['general.days_ago']
                );
            } else if (elapsed < msPerYear) {
                return (
                    Math.round(elapsed / msPerMonth) +
                    ' ' +
                    this.translations['general.months_ago']
                );
            } else {
                return (
                    Math.round(elapsed / msPerYear) +
                    ' ' +
                    this.translations['general.years_ago']
                );
            }
        },

        refreshStickySidebar() {
            this.$nextTick(() => {
                var resizeEvent = window.document.createEvent('UIEvents');

                resizeEvent.initUIEvent('resize', true, false, window, 0);

                window.dispatchEvent(resizeEvent);
            });
        },

        getValidUrl(url = '', secure = false) {
            let newUrl = window.decodeURIComponent(url);
            newUrl = newUrl.trim().replace(/\s/g, '');

            if (/^(:\/\/)/.test(newUrl)) {
                return secure ? `https${newUrl}` : `http${newUrl}`;
            }
            if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
                return secure ? `https://${newUrl}` : `http://${newUrl}`;
            }

            return newUrl;
        },
    },

    created() {
        if (typeof this.onCreated === 'function') {
            this.onCreated();
        }
    },

    mounted() {
        if (typeof this.onMounted === 'function') {
            this.onMounted();
        }
    },

    filters: {
        getDateHumanFormat: function (date) {
            return moment(date).fromNow();
        },
    },
};
